import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, Button, List, ListItem, ListItemText, FormHelperText } from '@material-ui/core';

class VoterDataAutocomplete extends React.Component {
  state = {
    fetching: false,
    dialogVisible: false,
    voters: [],
    error: null,
  }

  handleSuggestVoters = () => {
    this.setState({ fetching: true, error: null });
    this.props
      .onSuggestVoters(this.props.values)
      .then(result => {
        if (!result.length) {
          this.setState({ error: 'Nie znaleziono danych spełniających wprowadzone kryteria'});
        } else if (result.length === 1) {
          this.updateVoterData(result[0]);
        } else {
          this.setState({ dialogVisible: true, voters: result });
        }
      })
      .finally(() => this.setState({ fetching: false }));
  }

  updateVoterData = voter => {
    this.props.change('voter', voter);
    if (this.props.streetsAutocompleteData) {
      if (voter.city) {
        const city = this.props.streetsAutocompleteData.find(d => d.cityName === voter.city);
        if (city) {
          this.props.change('voter.cityId', city.cityId);
          this.props.change('voter.city', city.cityName);
        
          const street = this.props.streetsAutocompleteData.find(d => d.name === voter.address && d.cityId === city.cityId);
          if (street) {
            this.props.change('voter.addressId', street.id);
            this.props.change('voter.address', street.name);
          }
        }
      }
    }
  }

  isSearchActive = () => {
    const firstNamePresent = this.props.values.firstName;
    const otherPropertiesPresent = Object.keys(this.props.values)
      .filter(k => k !== 'firstName' && k !== 'cityId' && k !== 'addressId')
      .filter(k => this.props.values[k] != null)
      .length >= 2;

    return firstNamePresent && otherPropertiesPresent;
  }

  closeDialog = () => {
    this.setState({ dialogVisible: false, voters: [] });
  }

  handleVoterSelected = voter => {
    this.closeDialog();
    this.updateVoterData(voter);
  }

  render() {
    const { fetching, dialogVisible, voters, error } = this.state;
    return (
      <React.Fragment>
        <Button
          color="primary"
          disabled={!this.isSearchActive() || fetching}
          onClick={this.handleSuggestVoters}
          fullWidth
          style={{marginTop: 16, marginBottom: 10}}
          variant="contained"

        >
          Wyszukaj osobę
        </Button>
        {error && <FormHelperText error>{error}</FormHelperText>}
        <Dialog open={dialogVisible} aria-labelledby="dialog-title" maxWidth="md" onClose={this.closeDialog}>
          <DialogTitle id="dialog-title">Wybierz osobę</DialogTitle>
          <DialogContent>
            <List>
              {voters.map((voter, i) => (
                <ListItem
                  key={i}
                  button
                  onClick={() => this.handleVoterSelected(voter)}
                >
                  <ListItemText
                    primary={`${voter.firstName} ${voter.lastName}`}
                    secondary={`${voter.city || ''} ${voter.address || ''} ${voter.number || ''} ${voter.localNumber || ''}; Imię matki: ${voter.motherName || ''}; Imię ojca: ${voter.fatherName || ''}; Miejsce urodzenia: ${voter.birthPlace || ''}`}
                  />
                </ListItem>
              ))}
            </List>
          </DialogContent>
        </Dialog>
      </React.Fragment>);
  }
}

VoterDataAutocomplete.defaultProps = {
  values: {},
};

VoterDataAutocomplete.propTypes = {
  voterRequiredData: PropTypes.object.isRequired,
  change: PropTypes.func.isRequired,
  values: PropTypes.object,
  onSuggestVoters: PropTypes.func,
  streetsAutocompleteData: PropTypes.array,
};

export default VoterDataAutocomplete;



// WEBPACK FOOTER //
// ./src/components/budget/voting/VoterDataAutocomplete.js